module.exports = __webpack_public_path__ + "static/media/Libuda.ed06976b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Libuda.svg
// module id = 931
// module chunks = 0